import { render } from "./CustomInput.vue?vue&type=template&id=fef1727e&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import "./CustomInput.vue?vue&type=style&index=0&id=fef1727e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef1727e"]])

export default __exports__